<div class="p-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">
      {{ adapterData.isUpdate ? 'Edit' : ' Add New' }}
      Adapter Setting
    </h5>
    <img
      src="assets/images/close-icon.svg"
      alt="close-icon"
      class="cursor-pointer"
      [attr.aria-hidden]="true"
      (click)="closeDialogRef.close(false)" />
  </div>

  <form
    class="mat-form"
    [formGroup]="upsertAdapterSettingFrom"
    (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 form-group">
        <app-input-template
          [inputData]="attrConstant.adapterType"
          [formControlName]="
            attrConstant.adapterType.key
          "></app-input-template>
      </div>
      <div class="col-md-12 form-group">
        <app-input-template
          [inputData]="attrConstant.adapter"
          [formControlName]="attrConstant.adapter.key"></app-input-template>
      </div>
      <div class="col-md-12 form-group">
        <app-input-template
          [inputData]="attrConstant.description"
          [formControlName]="attrConstant.description.key"></app-input-template>
      </div>
      <div class="col-md-12 scrollbar pb-1">
        <mat-card formArrayName="settings">
          <mat-card-title class="h4">Settings</mat-card-title>
          <mat-divider class="position-relative mb-2"></mat-divider>
          <div *ngFor="let setting of settingData.controls; let i = index">
            <mat-divider
              *ngIf="settingData.controls.length > 1 && i > 0"
              class="position-relative mb-2"></mat-divider>
            <div [formGroupName]="i">
              <div class="row align-items-center">
                <div class="col-md-5 form-group">
                  <app-input-template
                    [inputData]="attrConstant.name"
                    [formControlName]="
                      attrConstant.name.key
                    "></app-input-template>
                </div>
                <div class="col-md-5 form-group">
                  <app-input-select
                    [inputData]="attrConstant.dataType"
                    [selectOptions]="dataType"
                    [bindLabel]="'name'"
                    [bindValue]="'value'"
                    [formControlName]="
                      attrConstant.dataType.key
                    "></app-input-select>
                </div>
                <div
                  class="col-md-2 text-end ps-0"
                  *ngIf="settingData.controls.length > 1">
                  <a
                    (click)="removeSettingRow(i)"
                    mat-stroked-button
                    color="warn"
                    class="dlt-btn border-0"
                    [attr.aria-hidden]="true">
                    <mat-icon class="m-0">delete forever</mat-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <mat-card-actions class="row mt-2 justify-content-end">
            <div class="col-md-5 text-end">
              <a
                mat-stroked-button
                class="ubx-primary"
                [attr.aria-hidden]="true"
                (click)="addSettingRow()">
                + Add New Setting
              </a>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div class="row mt-3 justify-content-end">
      <div class="col-md-6">
        <button
          class="btn primary-btn w-100"
          [ngClass]="isSubmitLoading ? 'dsbld' : 'enbld'">
          <img
            *ngIf="isSubmitLoading"
            src="assets/images/button-spinner.svg"
            alt="button-spinner" />{{ adapterData.isUpdate ? 'Update' : 'Add' }}
        </button>
      </div>
    </div>
  </form>
</div>
